export default "__VITE_ASSET__C7If5RBu__"